// Opt-in switch to run the dashboard against the LOCAL Firebase emulators (end-to-end tests of the Firestore rules
// and of the invoice lock). It is inert unless REACT_APP_FIREBASE_EMULATORS=1 is set when the dev server starts or
// the bundle is built, and it is ignored in a production build even if the variable leaked into the environment.
//
//   REACT_APP_FIREBASE_EMULATORS=1                       switch on
//   REACT_APP_FIREBASE_EMULATOR_HOST=localhost           (default)
//   REACT_APP_FIREBASE_EMULATOR_FIRESTORE_PORT=8080      (default)
//   REACT_APP_FIREBASE_EMULATOR_FUNCTIONS_PORT=5001      (default; nothing needs to listen: a callable then fails
//                                                         fast on localhost instead of reaching a real project)
//
// Use it with a demo project id (REACT_APP_PROJECT_ID=demo-...), never with the real one.
//
// Firebase Auth has no switch here: the web SDK in use (firebase 7.19) predates `auth.useEmulator()` (7.21). A test
// harness has to send the Identity Toolkit calls (identitytoolkit / securetoken) to the Auth emulator itself.

const DEFAULT_HOST = 'localhost';
const DEFAULT_FIRESTORE_PORT = 8080;
const DEFAULT_FUNCTIONS_PORT = 5001;

const portFrom = (value, fallback) => {
  const port = Number(value);
  return Number.isInteger(port) && port > 0 && port < 65536 ? port : fallback;
};

/** null = inert (the normal case); otherwise where the emulators are. */
export function getEmulatorConfig(env) {
  if (!env || env.REACT_APP_FIREBASE_EMULATORS !== '1') return null;
  if (env.NODE_ENV === 'production') return null;
  const host = env.REACT_APP_FIREBASE_EMULATOR_HOST || DEFAULT_HOST;
  const firestorePort = portFrom(env.REACT_APP_FIREBASE_EMULATOR_FIRESTORE_PORT, DEFAULT_FIRESTORE_PORT);
  const functionsPort = portFrom(env.REACT_APP_FIREBASE_EMULATOR_FUNCTIONS_PORT, DEFAULT_FUNCTIONS_PORT);
  return {
    firestore: { host: `${host}:${firestorePort}`, ssl: false },
    functionsOrigin: `http://${host}:${functionsPort}`,
  };
}

/** Points Firestore and the callable functions at the emulators. Returns whether it did anything. */
export function connectToEmulators({ db, functions }, config) {
  if (!config) return false;
  db.settings(config.firestore);
  functions.useFunctionsEmulator(config.functionsOrigin);
  return true;
}
